import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminLayout from './components/layouts/AdminLayout';
import AdminDashboard from './pages/admin/Dashboard';
import AdminProjects from './pages/admin/Projects';
import AdminSettings from './pages/admin/Settings';
import Login from './pages/admin/Login';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Hero from './pages/admin/Hero';
import FooterManager from './components/admin/FooterManager';
import FaviconLoader from './components/common/FaviconLoader';
import { FeatureManager } from './components/admin/FeatureManager';
import Testimonials from './pages/admin/Testimonials';
import AdminContact from './pages/admin/Contact';
import AdminAbout from './pages/admin/About';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        {/* Load favicon when app starts */}
        <FaviconLoader />
        <Routes>
          {/* Public Routes */}
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          {/* Admin Login */}
          <Route path="/admin/login" element={<Login />} />

          {/* Protected Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="hero" element={<Hero />} />
            <Route path="features" element={<FeatureManager />} />
            <Route path="testimonials" element={<Testimonials />} />
            <Route path="about" element={<AdminAbout />} />
            <Route path="contact" element={<AdminContact />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="footer" element={<FooterManager />} />
          </Route>
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App; 